export default "__VITE_ASSET__McULJTmw__"